// apps/dashboard/src/components/chrome/AuthShell.tsx
import type { ReactNode } from "react";

// Auth shell wraps /sign-in and /sign-up. Just a viewport-locked centering
// container — Clerk's SignIn/SignUp card carries its own branding, so this
// doesn't render a wordmark of its own.
interface AuthShellProps {
  children: ReactNode;
}

export function AuthShell({ children }: AuthShellProps) {
  return (
    <div className="h-screen bg-bg-1 overflow-hidden flex items-center justify-center p-6">
      {children}
    </div>
  );
}
